import moment from 'moment';
import 'moment-timezone';
import { RenderCommaMoney } from './FormatMoney';

// ตัวช่วยแสดงผลของเมนู Point expire (การตัดแต้มหมดอายุ)
// กติกา: แต้มที่อนุมัติช่วง 1 ม.ค.–30 มิ.ย. หมดอายุสิ้นวัน 31 ธ.ค. ปีเดียวกัน
//        แต้มที่อนุมัติช่วง 1 ก.ค.–31 ธ.ค. หมดอายุสิ้นวัน 30 มิ.ย. ปีถัดไป
//        ล็อตเรียกว่า period_key เช่น "2026H1" / แต้มก่อน 1 ม.ค. 2569 = ล็อต "legacy" ไม่หมดอายุ

export const TIME_ZONE = 'Asia/Bangkok';
export const LEGACY_LOT_KEY = 'legacy';

export const formatDateTime = (date) =>
  date ? moment(date).tz(TIME_ZONE).format('DD/MM/YYYY HH:mm:ss') : '-';

export const formatDate = (date) =>
  date ? moment(date).tz(TIME_ZONE).format('DD/MM/YYYY') : '-';

// แต้มแสดงแบบมี comma (0 → "0", ค่าลบแสดงเครื่องหมายลบ)
export const formatPoint = (value) =>
  value === undefined || value === null
    ? '-'
    : RenderCommaMoney(Number(value), true);

export const formatDuration = (ms) => {
  const total = Math.round(Number(ms || 0) / 1000);
  if (!total) return '-';
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;
  if (!minutes) return `${seconds} วินาที`;
  return `${minutes} นาที ${seconds} วินาที`;
};

export const RENDER_LOT_LABEL = (key) =>
  key === LEGACY_LOT_KEY ? 'ก่อนเริ่มระบบ (ไม่หมดอายุ)' : key || '-';

// ---------- สถานะรายการตัดแต้ม (point_expire_log) ----------
export const LOG_STATUS_OPTIONS = [
  { label: 'All', value: '0' },
  { label: 'สำเร็จ', value: 'success' },
  { label: 'ไม่สำเร็จ', value: 'fail' },
  { label: 'ค้างดำเนินการ', value: 'processing' },
  { label: 'ยกเลิกแล้ว', value: 'reverted' },
];

export const RENDER_LOG_STATUS = (status) => {
  switch (status) {
    case 'success':
      return 'สำเร็จ';
    case 'fail':
      return 'ไม่สำเร็จ';
    case 'processing':
      return 'ค้างดำเนินการ';
    case 'reverted':
      return 'ยกเลิกแล้ว';
    default:
      return status || '-';
  }
};

// ---------- สถานะรอบตัดแต้ม (point_expire_run) ----------
export const RUN_STATUS_OPTIONS = [
  { label: 'All', value: '0' },
  { label: 'สำเร็จ', value: 'success' },
  { label: 'สำเร็จบางส่วน', value: 'partial' },
  { label: 'ไม่สำเร็จ', value: 'fail' },
  { label: 'กำลังรัน', value: 'running' },
  { label: 'ยกเลิกแล้ว', value: 'reverted' },
];

export const RENDER_RUN_STATUS = (status) => {
  switch (status) {
    case 'success':
      return 'สำเร็จ';
    case 'partial':
      return 'สำเร็จบางส่วน';
    case 'fail':
      return 'ไม่สำเร็จ';
    case 'running':
      return 'กำลังรัน';
    case 'reverted':
      return 'ยกเลิกแล้ว';
    default:
      return status || '-';
  }
};

export const RENDER_TRIGGER = (trigger) => {
  switch (trigger) {
    case 'cron':
      return 'ระบบอัตโนมัติ';
    case 'script':
      return 'เจ้าหน้าที่สั่งรัน';
    case 'repair':
      return 'รันซ้ำหลังยกเลิกรายการ';
    default:
      return trigger || '-';
  }
};

export const MISMATCH_OPTIONS = [
  { label: 'All', value: '0' },
  { label: 'เฉพาะยอดไม่ตรง', value: 'true' },
];

// ---------- แถว ledger (wallet_history) ----------
// คู่ action_type/status: 3/1 รับแต้ม, 2/2 แลกของรางวัล, 4/6 ปรับแก้ system error,
// 4/1 ยอดยกมา (รับ), 4/2 ยอดยกมา (แลก) = แถว bootstrap ledger วันที่ 22 ส.ค. 2566,
// 5/7 ตัดแต้มหมดอายุ, 5/8 ตัดแต้มที่ถูกยกเลิก (revert)
export const RENDER_LEDGER_ACTION = (row) => {
  if (!row) return '-';
  const key = `${row.action_type}/${row.status}`;
  switch (key) {
    case '3/1':
      return 'รับแต้ม';
    case '4/1':
      return 'ยอดยกมา (รับ)';
    case '2/2':
      return 'แลกของรางวัล';
    case '4/2':
      return 'ยอดยกมา (แลก)';
    case '4/6':
      return 'ปรับแก้ system error';
    case '5/7':
      return 'ตัดแต้มหมดอายุ';
    case '5/8':
      return 'ตัดแต้มหมดอายุ (ยกเลิกแล้ว)';
    default:
      return key;
  }
};

// แต้มในแถว ledger พร้อมเครื่องหมาย (+ รับ / - แลก,ตัด / ปรับแก้ใช้เครื่องหมายตามที่บันทึก)
export const LEDGER_SIGNED_POINT = (row) => {
  if (!row) return 0;
  const point = Number(row.point || 0);
  const key = `${row.action_type}/${row.status}`;
  if (key === '2/2' || key === '4/2' || key === '5/7' || key === '5/8') {
    return -Math.abs(point);
  }
  if (key === '3/1' || key === '4/1') return Math.abs(point);
  return point;
};

export const LEDGER_SIGNED_LABEL = (row) => {
  const point = LEDGER_SIGNED_POINT(row);
  return point > 0 ? `+${formatPoint(point)}` : formatPoint(point);
};

// ---------- ตัวเลือกล็อตสำหรับ dropdown ----------
// ตัด legacy ออก (API preview ไม่รับล็อต legacy) และใส่สถานะต่อท้ายให้ดูง่าย
export const PERIOD_OPTIONS = (periods, { withAll } = {}) => {
  const list = (periods || [])
    .filter((p) => !p.is_legacy)
    .map((p) => ({
      value: p.key,
      label: `${p.key} (${p.received_label}) → หมดอายุ ${
        p.expire_short_label || p.expire_label
      }${PERIOD_STATUS_SUFFIX(p)}`,
    }));
  return withAll ? [{ label: 'All', value: '0' }, ...list] : list;
};

const PERIOD_STATUS_SUFFIX = (p) => {
  if (p.done_at || p.last_run_status === 'success') return ' • ตัดแล้ว';
  if (p.is_due) return ' • ครบกำหนด';
  if (p.is_collecting) return ' • กำลังสะสม';
  return '';
};

export const RENDER_PERIOD_STATE = (p) => {
  if (!p) return '-';
  if (p.done_at || p.last_run_status === 'success') return 'ตัดแต้มแล้ว';
  if (p.is_due) return 'ครบกำหนดแล้ว (รอรอบตัด)';
  if (p.is_collecting) return 'กำลังสะสม (ยังไม่ครบกำหนด)';
  return 'ยังไม่ครบกำหนด';
};

// ---------- Excel ของรายการตัดแต้ม (ใช้ทั้งหน้า Expire history และ Run history) ----------
export const POINT_EXPIRE_LOG_SHEET_HEADER = [
  'No',
  'วันที่ตัด',
  'Login ID',
  'CU code',
  'ล็อต',
  'วันหมดอายุ',
  'ได้รับในล็อต',
  'ใช้ไปจากล็อต',
  'คงเหลือในล็อต',
  'ยอดตาม ledger',
  'Wallet ก่อนตัด',
  'ยอดที่ตัด',
  'Wallet หลังตัด',
  'ยอดไม่ตรง',
  'สาเหตุยอดไม่ตรง',
  'สถานะ',
  'ข้อผิดพลาด',
  'ตัดโดย',
  'การซ่อม',
  'เหตุผลการซ่อม',
  'แอดมินที่ซ่อม',
  'Run ID',
];

export const POINT_EXPIRE_LOG_SHEET_COLS = [
  { wch: 5 },
  { wch: 20 },
  { wch: 30 },
  { wch: 15 },
  { wch: 10 },
  { wch: 14 },
  { wch: 14 },
  { wch: 14 },
  { wch: 14 },
  { wch: 14 },
  { wch: 14 },
  { wch: 12 },
  { wch: 14 },
  { wch: 10 },
  { wch: 50 },
  { wch: 14 },
  { wch: 40 },
  { wch: 20 },
  { wch: 12 },
  { wch: 40 },
  { wch: 20 },
  { wch: 26 },
];

export const POINT_EXPIRE_LOG_SHEET_ROW = (e, i) => [
  i + 1,
  formatDateTime(e.expired_run_at || e.created_at),
  `${e.customer_user_id || ''}`,
  `${e.customer_cu_id || ''}`,
  e.period_key,
  formatDate(e.expire_at),
  formatPoint(e.lot_received),
  formatPoint(e.lot_redeemed),
  formatPoint(e.lot_remaining),
  formatPoint(e.ledger_balance),
  formatPoint(e.wallet_point_before),
  formatPoint(e.expired_point),
  e.wallet_point_after === undefined || e.wallet_point_after === null
    ? ''
    : formatPoint(e.wallet_point_after),
  e.is_mismatch ? 'ใช่' : '',
  e.mismatch_reason || '',
  RENDER_LOG_STATUS(e.status),
  e.error_message || '',
  RENDER_TRIGGER(e.trigger),
  e.repair_action || '',
  e.repair_reason || '',
  e.repair_admin_username || '',
  e.run_ref_id ? `${e.run_ref_id}` : '',
];
